<template>
  <header>
      <router-link to="/Professeur" class="sdl"><img src="../../assets/Studio des langues.svg"></router-link>

      <img src="../../assets/user.png" class="user">
  </header>
</template>

<script>


export default {
    
}
</script>

<style>
    header{
        background-color: #4D908E;
        border-bottom: solid 1px #000;
        height: 80px;
        font-family: 'Satisfy', Courier, monospace;
        font-weight: 100;
        color: #FFF;
        padding: 0 0 0 1%;
        display: flex;
        align-items: center;
    }

    .sdl{
        width: 18%;
        cursor: pointer;
    }

    .user{
        width: 4%;
        margin-left: 77%;
    }

    @font-face {
        font-family: Satisfy;
        src: url('../../../public/font/Satisfy/Satisfy-Regular.ttf');
    }
</style>